import { LanguageHolder } from "@tlc/ls2pac/components/Language";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { BaseView } from "../../ls2pac/views/BaseView";
import { seriesLogo } from "../SeriesLogo";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsCategoryManager } from "../managers/categoryManager";
import { KidsSeriesManager } from "../managers/seriesManager";
import { KidsMessaging } from "../messaging";

/**
 * The footer view, nothing really interesting is here.
 * tlc.ls2kids.views.FooterView
 */
export class KidsFooterView extends BaseView {
	constructor() {
		super({
			id: LS2KIDS_CONSTANTS.Ids.mainFooter,
			baseTemplate: 'tmpl/kids/footerView.html',
			viewClass: 'structureView'
		});

		this._randomCategory = {};
		this._randomSeries = {};
		this._languageButtons = null;


		this.show({
			"additionalLinks": ApplicationData.locationConfiguration.getAdditionalLinks(),
			"target": ApplicationData.locationConfiguration.getAdditionalLinkBehavior(),
			"year": (new Date()).getFullYear(),
			"libraryName": ApplicationData.locationConfiguration.getLibraryName()
		});

		this.addEventListeners();
	}
	/**
	 * Attach any events for the footer.
	 * @override
	 */
	async load() {
		var _this = this;

		this._$exploreCategoriesEle = $("#" + LS2KIDS_CONSTANTS.Ids.footer.exploreCategories);
		this._$exploreSeriesEle = $("#" + LS2KIDS_CONSTANTS.Ids.footer.exploreSeries);
		this._$currentSearchIcon = $("#" + LS2KIDS_CONSTANTS.Ids.footer.currentSearchIcon);
		this._$mainAppEle = $("#" + LS2KIDS_CONSTANTS.Ids.app);
		this._$languageControl = $("#" + LS2PAC_CONSTANTS.Ids.Footer.languageSelectionControl);

		this.$view.addClass('structureView');

		this.createCategoryIcons();

		if (KidsSeriesManager.hasSeries()) {
			this.createSeriesIcons();
		} else {
			this.$view.addClass('no-series');
		}

		this.initEvents();

		window.requestAnimationFrame(function () {
			_this.$view.removeClass('hide-opacity');
		});

		this.initRotation();

		const availableLanguages = await LanguageHolder.getAvailableLanguages();
		this.addLanguageLinks(availableLanguages);
	}
	addLanguageLinks(languages) {
		var currentLanguage = LanguageHolder.languageCode;

		this._languageButtons = [];

		for (var i = 0, len = languages.length; i < len; i += 1) {
			var language = languages[i];

			if (language.code != currentLanguage) {
				this._languageButtons.push({
					"label": language.displayName,
					"id": language.code
				});
			} else {
				this._$languageControl.html(language.displayName + " (" + ApplicationData.language.kidsSelectAnotherLanguage + ")");
			}
		}

		// if (communityTrackingEnabled === true || customerTrackingEnabled === true) {
		// 	$('#footerLinks').find('.privacyLink').show();
		// }
		// else {
		// 	$('#footerLinks').find('.privacyLink').hide();
		// }
	}
	initEvents() {
		var _this = this;

		var fanTimeout = null;

		this._$exploreCategoriesEle.on('touchstart', function () {
			if (fanTimeout != null) {
				clearTimeout(fanTimeout);
				fanTimeout = null;
			}
		});

		this._$exploreCategoriesEle.on('touchend', function () {
			_this._$exploreCategoriesEle.addClass('fan');

			fanTimeout = setTimeout(function () {
				window.requestAnimationFrame(function () {
					_this._$exploreCategoriesEle.removeClass('fan');
				});
			}, 500);
		});

		this._$languageControl.on('click', function () {
			KidsMessaging.confirm({
				message: "<span>" + ApplicationData.language.kidsSelectYourLanguage + "</span>",
				buttons: _this._languageButtons,
				failButton: ApplicationData.language.kidsForgetIt,
				wrapperCustomClass: "ebook-format-selection-buttons",
				successCallback: async function (id) {
					await LanguageHolder.updateLanguageCode(id);
					// wait for the new language to be set on the backend then refresh the page
					window.location.reload(); // once everything is in React, we won't need to refresh
				}
			});
		});
	}
	addEventListeners() {
		TLCEvents.on(LS2KIDS_CONSTANTS.Events.onHideCurrentSearchIcon, this.onHideCurrentSearchIcon, this);
		TLCEvents.on(LS2KIDS_CONSTANTS.Events.onShowCurrentSearchIcon, this.onShowCurrentSearchIcon, this);
	}
	swapCategoryIcon() {
		var _this = this;

		var randomImage = this._lastCategoryRandomIndex;

		while (randomImage == this._lastCategoryRandomIndex) {
			randomImage = Math.floor(Math.random() * this._categoryIcons.length);
		}

		var randomCategory = KidsCategoryManager.getRandomCategory(this._randomCategory);
		var categoryImageUrl = LS2KIDS_CONSTANTS.restUrls.category.onImage(randomCategory.id);
		var icon = this._categoryIcons[randomImage];
		var other = icon.next();

		if (!other.hasClass('hide-icon')) {
			var temp = icon;
			icon = other;
			other = temp;
		}

		other.find('img').attr('src', categoryImageUrl);

		icon.addClass('hide-icon');
		other.removeClass('hide-icon');

		_this._lastCategoryRandomIndex = randomImage;
	}
	swapSeriesIcon() {
		var _this = this;

		var randomImage = this._lastSeriesRandomIndex;

		while (randomImage == this._lastSeriesRandomIndex) {
			randomImage = Math.floor(Math.random() * this._seriesIcons.length);
		}

		var randomSeries = KidsSeriesManager.getRandomSeries(this._randomSeries);

		if (randomSeries != null) {
			var seriesImageUrl = seriesLogo(randomSeries.logos[0], this._iconWidth, this._iconHeight);
			var icon = this._seriesIcons[randomImage];
			var other = icon.next();

			if (!other.hasClass('hide-icon')) {
				var temp = icon;
				icon = other;
				other = temp;
			}

			icon.addClass('hide-icon');

			setTimeout(function () {
				icon.find('img').attr('src', seriesImageUrl);
			}, 500);

			other.removeClass('hide-icon');

			_this._lastSeriesRandomIndex = randomImage;
		}
	}
	initRotation() {
		var _this = this;

		setTimeout(function () {
			window.requestAnimationFrame(function () {
				if (_this._rotationOrder) {
					_this.swapCategoryIcon();
				} else {
					if (KidsSeriesManager.hasSeries()) {
						_this.swapSeriesIcon();
					}
				}

				_this.initRotation();
				_this._rotationOrder = !_this._rotationOrder;
			});
		}, 3000);
	}
	createCategoryIcons() {
		this._$exploreCategoriesEle = $("#" + LS2KIDS_CONSTANTS.Ids.footer.exploreCategories);

		this._categoryIcons = [];

		var total = 4;

		var iconContainer = $('<div class="icon-wrapper"></div>');

		for (var i = 0; i < total; i += 1) {
			var randomCategory = KidsCategoryManager.getRandomCategory(this._randomCategory);

			if (randomCategory == null) {
				return;
			}

			var icon = $(
				'<span class="icon">' +
				'<span class="glass-like-background">' +
				'<span class="image-wrapper">' +
				'<img src="' + LS2KIDS_CONSTANTS.restUrls.category.onImage(randomCategory.id) + '" role="presentation" alt="" />' +
				'</span>' +

				'<span class="image-wrapper hide-icon">' +
				'<img src="' + LS2KIDS_CONSTANTS.restUrls.category.onImage(randomCategory.id) + '" role="presentation" alt="" />' +
				'</span>' +
				'</span>' +
				'</span>'
			);

			if (i % 2 == 1) {
				icon.addClass('icon-odd');
			}

			if (i > (total - 1) / 2) {
				icon.addClass('icon-first-half');
			} else {
				icon.addClass('icon-second-half');
			}

			this._categoryIcons.push(icon.find('.image-wrapper:first-child'));

			iconContainer.prepend(icon);
		}
		this._$exploreCategoriesEle.prepend(iconContainer);
	}
	createSeriesIcons() {
		this._seriesIcons = [];

		var total = 4;

		var iconContainer = $('<div class="icon-wrapper"></div>');

		for (var i = 0; i < total; i += 1) {
			var randomSeries = KidsSeriesManager.getRandomSeries(this._randomSeries);
			var randomSeries2 = KidsSeriesManager.getRandomSeries(this._randomSeries);

			if (randomSeries == null) {
				break;
			}

			var icon = $(
				'<span class="icon">' +
				'<span class="glass-like-background">' +
				'<span class="image-wrapper">' +
				'<img src="' +
				seriesLogo(randomSeries.logos[0], this._iconWidth, this._iconHeight) +
				'" role="presentation" alt="" />' +
				'</span>' +

				'<span class="image-wrapper hide-icon">' +
				'<img src="' +
				seriesLogo(randomSeries2.logos[0], this._iconWidth, this._iconHeight) +
				'" role="presentation" alt="" />' +
				'</span>' +
				'</span>' +
				'</span>'
			);

			if (i % 2 == 1) {
				icon.addClass('icon-odd');
			}

			if (i > (total - 1) / 2) {
				icon.addClass('icon-first-half');
			} else {
				icon.addClass('icon-second-half');
			}

			this._seriesIcons.push(icon.find('.image-wrapper:first-child'));

			iconContainer.prepend(icon);

			icon.find('img').on('load', function (event) {
				$(event.currentTarget).centerVertically2();
			});
		}

		this._$exploreSeriesEle.prepend(iconContainer);
	}
	onHideCurrentSearchIcon() {
		if (this._$mainAppEle != null) {
			this._$mainAppEle.removeClass('show-current-search');
		}
	}
	onShowCurrentSearchIcon(event) {
		this._$currentSearchIcon.attr('src', event.imageUrl);

		this._$mainAppEle.addClass('show-current-search');
	}
}

/**
 *
 * @type {jQuery}
 * @private
 */
KidsFooterView.prototype._exploreCategories = null;
/**
 *
 * @type {boolean}
 * @private
 */
KidsFooterView.prototype._rotationOrder = null;

/**
 * All the category icons for the explore categories piece
 */
KidsFooterView.prototype._categoryIcons = null;
/**
 * An object to maintain the state for random categories.
 * @type {Object}
 * @private
 */
KidsFooterView.prototype._randomCategory = null;

/**
 * An object to maintain the state for random series.
 * @type {Object}
 * @private
 */
KidsFooterView.prototype._randomSeries = null;

/**
 * The last index used when changing category cons.
 * @type {Array.<number>}
 * @private
 */
KidsFooterView.prototype._lastCategoryRandomIndex = null;

/**
 * The last index used when changing series icons.
 * @type {Array.<number>}
 * @private
 */
KidsFooterView.prototype._lastSeriesRandomIndex = null;

KidsFooterView.prototype._iconWidth = 52;
KidsFooterView.prototype._iconHeight = 52;














